import { Set } from '~commonInfra/utils/Set';

import { AuthenticationTypeResolutionService } from '../../../authentication/services/AuthenticationTypeResolutionService';
import { AuthenticationProviderType, IAuthenticationProvider } from '../../../settings/siteAuthSettings/services/SiteAuthenticationSettingsService';
import { UserActionNotification, UserActionNotificationParams } from '../../services/notifications/UserActionNotification';
import { SiteUsers } from '../../services/resources/SiteUsers';
import { SiteRoles } from '../../users/serverApi/types/ISiteRole';
import { IUserActionResult, UserActionResultCode } from '../../users/serverApi/types/IUserActionResult';
import { AddLocalUsersDialogProps, INewUserFlowModel } from '../AddLocalUsersDialog';

export class CreateLocalSiteUserHelperService {
  private userActionNotification: UserActionNotification = UserActionNotification.instance;

  public createLocalSiteUser(username: string, model: INewUserFlowModel, siteRole: string,
                             authenticationProvider: IAuthenticationProvider, props: AddLocalUsersDialogProps,
                             setErrorTextCallback: (errorMsg: string) => void,
                             setBusyState: (busy: boolean) => void) {
    // get the currently selected site role off the scope
    let siteRoleToGiveNewUser = siteRole;
    // set a flag to true if the currently selected role is Server Admin
    const makeServerAdmin = (siteRoleToGiveNewUser === SiteRoles.ServerAdministrator) || null;
    // if setting to server admin, we don't pass the role to the backend.
    // because the server admin flag & the site role string are mutually exclusive.
    if (makeServerAdmin) {
      siteRoleToGiveNewUser = null;
    }
    let action: Promise<IUserActionResult>;
    const isLocalAuth = authenticationProvider.type === AuthenticationProviderType.default && !AuthenticationTypeResolutionService.isAuthenticationSaml();
    if (isLocalAuth) {
      action = SiteUsers.instance.createLocalUser(
        username,
        model.displayName,
        model.email,
        model.password,
        makeServerAdmin,
        siteRoleToGiveNewUser
      );
    } else {
      action = SiteUsers.instance.createLocalUserWithSamlOrSiteSamlAuth(
        username,
        model.displayName,
        model.email,
        authenticationProvider.id,
        makeServerAdmin,
        siteRoleToGiveNewUser
      );
    }
    action.then((result: any) => {
      this.showNotificationForCreateUser(result, siteRoleToGiveNewUser, setErrorTextCallback);
      if (!!result.errors && result.errors.length > 0) {
        setBusyState(false);
      } else {
        props.close(result);
      }
    });
  }

  public showNotificationForCreateUser(result: IUserActionResult, siteRole: string, setErrorTextCallback: (errorMsg: string) => void) {
    const params: UserActionNotificationParams = {
      users: Set.fromIdItemArray(result.users),
      results: result.results,
      errors: result.errors,
      successCode: UserActionResultCode.siteUserCreated,
      siteRole: siteRole,
      showErrorMsgFunc: (errorMsg: string) => {
        setErrorTextCallback(errorMsg);
      }
    };
    this.userActionNotification.notify(params);
  }
}
